var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { "max-width": "100%" }, attrs: { id: "newQianniuExamex" } },
    [
      _c("input", {
        ref: "fileInputSix",
        staticStyle: { display: "none" },
        attrs: { type: "file", accept: ".csv" },
        on: { change: _vm.onSixFileChange }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "el-tabs el-tabs--left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "el-tabs__content" }, [
          _c(
            "div",
            { staticClass: "el-tab-pane", attrs: { id: "tab-first-content" } },
            [
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "stoptip-first" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始实操练习")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-first" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerFirst",
                        attrs: {
                          steps: _vm.scenarioConfig.first.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.first.initialStepId,
                          "initial-form": _vm.scenarioConfig.first.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("first")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("first", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "first",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(1),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tip-body" },
                      [
                        _vm.tabCurrent === "first" &&
                        _vm.currentStepId.first === "login2"
                          ? [
                              _c("p", [_vm._v("1.复制粘贴账号和密码")]),
                              _vm._v(" "),
                              _c("p", [_vm._v("2.自动登录不要勾选")]),
                              _vm._v(" "),
                              !_vm.showLoginPassword
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: function($event) {
                                          _vm.showLoginPassword = true
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t获取账号密码\n\t\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.showLoginPassword
                                ? [_vm._m(2), _vm._v(" "), _vm._m(3)]
                                : _vm._e()
                            ]
                          : [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.rightTip.first)
                                }
                              })
                            ]
                      ],
                      2
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "stoptip",
                  staticStyle: { height: "696px" },
                  attrs: { id: "studytip-first" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-second", 2, "second")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "second" },
              attrs: { id: "tab-second-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-second" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-second" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerSecond",
                        attrs: {
                          steps: _vm.scenarioConfig.second.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.second.initialStepId,
                          "initial-form": _vm.scenarioConfig.second.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("second")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("second", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "second",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(4),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.second) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-second" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-third", 3, "third")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "third" },
              attrs: { id: "tab-third-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-third" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-third" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerThird",
                        attrs: {
                          steps: _vm.scenarioConfig.third.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.third.initialStepId,
                          "initial-form": _vm.scenarioConfig.third.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("third")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("third", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "third",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.third) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-third" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-four", 4, "four")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "four" },
              attrs: { id: "tab-four-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-four" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-four" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerFour",
                        attrs: {
                          steps: _vm.scenarioConfig.four.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.four.initialStepId,
                          "initial-form": _vm.scenarioConfig.four.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("four")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("four", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "four",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(6),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.four) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-four" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-five", 5, "five")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "five" },
              attrs: { id: "tab-five-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-five" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-five" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerFive",
                        attrs: {
                          steps: _vm.scenarioConfig.five.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.five.initialStepId,
                          "initial-form": _vm.scenarioConfig.five.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("five")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("five", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "five",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(7),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.five) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-five" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-six", 6, "six")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "six" },
              attrs: { id: "tab-six-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-six" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-six" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerSix",
                        attrs: {
                          steps: _vm.scenarioConfig.six.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.six.initialStepId,
                          "initial-form": _vm.scenarioConfig.six.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("six")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("six", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "six",
                              stepId,
                              step,
                              resolvedTip
                            )
                          },
                          "request-file": _vm.onRequestFile,
                          "download-file": _vm.downloadKjdyFile
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(8),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.six) }
                    }),
                    _vm._v(" "),
                    _vm.rightTip.six && _vm.rightTip.six.indexOf("下载") !== -1
                      ? _c("p", [
                          _c("a", { on: { click: _vm.downloadKjdyFile } }, [
                            _vm._v("点击下载“快捷短语.csv”")
                          ])
                        ])
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-six" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关，进入下一关吧")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: {
                            click: function($event) {
                              return _vm.studyNext("#tab-seven", 7, "seven")
                            }
                          }
                        },
                        [_vm._v("GO，下一关")]
                      )
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "el-tab-pane",
              class: { mynone: _vm.tabCurrent !== "seven" },
              attrs: { id: "tab-seven-content" }
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false"
                    }
                  ],
                  staticClass: "stoptip",
                  attrs: { id: "stoptip-seven" }
                },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.startStudy }
                        },
                        [_vm._v("开始考核")]
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "content", attrs: { id: "content-seven" } },
                [
                  _c(
                    "div",
                    { staticClass: "con-left", staticStyle: { padding: "0" } },
                    [
                      _c("StepPlayer", {
                        ref: "playerSeven",
                        attrs: {
                          steps: _vm.scenarioConfig.seven.steps,
                          "initial-step-id":
                            _vm.scenarioConfig.seven.initialStepId,
                          "initial-form": _vm.scenarioConfig.seven.initialForm,
                          "show-tip": false
                        },
                        on: {
                          finish: function($event) {
                            return _vm.onFinish("seven")
                          },
                          "guard-failed": function($event) {
                            return _vm.onGuardFailed("seven", $event)
                          },
                          "step-change": function(stepId, step, resolvedTip) {
                            return _vm.onStepChange(
                              "seven",
                              stepId,
                              step,
                              resolvedTip
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "con-right" }, [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "tip-body",
                      domProps: { innerHTML: _vm._s(_vm.rightTip.seven) }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "stoptip", attrs: { id: "studytip-seven" } },
                [
                  _c("div", { staticClass: "tip" }, [
                    _c("span", { staticClass: "el-icon-success" }),
                    _vm._v(" "),
                    _c("p", [_vm._v("考核通关")]),
                    _vm._v(" "),
                    _c("p", [
                      _c(
                        "a",
                        {
                          staticClass: "restart",
                          on: { click: _vm.restartStudy }
                        },
                        [
                          _c("i", { staticClass: "el-icon-refresh-left" }),
                          _vm._v("重考")
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "startstudy",
                          on: { click: _vm.goBack }
                        },
                        [_vm._v("返回")]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "el-tabs__header is-left" }, [
      _c("div", { staticClass: "el-tabs__nav-wrap is-left" }, [
        _c("div", { staticClass: "el-tabs__nav-scroll" }, [
          _c("div", { staticClass: "el-tabs__nav is-left" }, [
            _c("div", {
              staticClass: "el-tabs__active-bar is-left",
              staticStyle: { height: "50px", transform: "translateY(0px)" }
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left is-active",
                attrs: { id: "tab-first" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("1、登录拼多多商家版")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-second" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("2、基础设置")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-third" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("3、订单管理")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-four" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [
                    _vm._v("4、会话窗口常用功能")
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-five" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("5、插件常用功能")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-six" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("6、添加快捷回复")])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "el-tabs__item js-tab is-left",
                attrs: { id: "tab-seven" }
              },
              [
                _c("div", { staticClass: "tab-slot" }, [
                  _c("p", { staticClass: "title" }, [_vm._v("7、退出账号")])
                ])
              ]
            )
          ])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("账号：淘金云客服:小淘")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticStyle: { color: "red", "font-weight": "normal" } }, [
        _vm._v("密码：Tj1234")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [_c("span", { staticClass: "line" }), _vm._v("提示")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a510688a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a510688a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/simulate/pddExam.vue
// module id = 1296
// module chunks = 0